// eslint-disable-next-line no-restricted-imports
import { tv } from 'tailwind-variants';

export const commonStyles = tv({
  slots: {
    // Text styles
    sectionTitle: 'text-heading-sm font-medium',
    primaryHeading: 'text-heading-lg font-medium',
    secondaryHeading: 'text-heading-sm font-medium',
    markdownH1: 'text-body-lg font-medium tracking-[-0.01em]',
    markdownH2: 'text-body-md font-medium tracking-[-0.01em]',
    markdownH3: 'text-body-sm font-medium tracking-normal',
    body: 'text-body-sm font-normal tracking-normal',
    bodyBold: 'text-body-sm font-bold tracking-normal',

    // Layout styles
    section: 'flex flex-col gap-3',
    sectionContent: 'flex flex-col gap-4',
    subSection: 'flex flex-col gap-2',
    markdownContent: 'flex flex-col gap-2',
    content: 'flex flex-col gap-3',
    flexRow: 'flex-row',
    flexCol: 'flex flex-col',

    // Colors and states
    muted: 'text-textSupporting',
    subtle: 'text-textSecondary',

    // Specific component patterns
    amendment: 'flex flex-col gap-1',
    amendmentHeader: 'text-sm text-textSecondary',

    // List styles
    bullet: 'mr-1.5 text-sm font-normal',
    bulletItem: 'ml-2 flex-row',
    nestedBulletItem: 'ml-4 mt-0 flex-row',
  },
})();
